import React from 'react';
import cn from 'clsx';

import Typography from '../typography/typography';

import styles from './vehicle-license-vin-details.scss';

interface VehicleLicenseVinDetailProps {
  className?: string;
  license?: string;
  vin?: string;
}

function VehicleLicenseVinDetails(props: VehicleLicenseVinDetailProps) {
  const { className = '', license, vin } = props;
  return (
    <div
      className={cn(
        styles['container'],
        `vehicle-license-vin-details ${className}`
      )}
    >
      {license && (
        <Typography
          className={cn(
            styles['license-container'],
            'vehicle-license-vin-details__license-container'
          )}
          tag="div"
        >
          <Typography
            className={cn(
              styles['license-title'],
              'vehicle-license-vin-details__license-title'
            )}
            size="small"
            tag="span"
            weight="bold"
          >
            License Plate:
          </Typography>
          <Typography
            className={cn(
              styles['vehicle-title'],
              'vehicle-license-vin-details__vehicle-title'
            )}
            size="small"
            tag="span"
          >
            {license}
          </Typography>
        </Typography>
      )}
      {vin && (
        <Typography
          className={cn(
            styles['vin-container'],
            'vehicle-license-vin-details__vin-container'
          )}
          tag="div"
        >
          <Typography
            className={cn(
              styles['vin-title'],
              'vehicle-license-vin-details__vin-title'
            )}
            size="small"
            tag="span"
            weight="bold"
          >
            VIN:
          </Typography>
          <Typography
            className={cn(
              styles['vehicle-title'],
              'vehicle-license-vin-details__vehicle-title'
            )}
            size="small"
            tag="span"
          >
            {vin}
          </Typography>
        </Typography>
      )}
    </div>
  );
}

export default VehicleLicenseVinDetails;
